import { LoadablePaint } from '@confluence/loadable';

export const EngagementInlineDialogLoader = LoadablePaint<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EngagementInlineDialogWrapper" */ './EngagementInlineDialogWrapper.tsx'
			)
		).EngagementInlineDialogWrapper,
});
